import {h} from 'preact'
import { Table, Tag, Button, Tooltip, Typography, message } from 'antd';
import {

    CopyOutlined,
    UserOutlined,
    CalendarOutlined
} from '@ant-design/icons';
import { SERVICE_OPTIONS, STATUS_COLORS } from '../constants/licenseConstants';
import { getStatus, copyToClipboard } from '../utils/licenseUtils';
import dayjs from 'dayjs';

const { Text } = Typography;

const LicenseKeyTable = ({
                             licenseKeys,
                             loading,
                         }) => {
    const handleCopy = async (key) => {
        const success = await copyToClipboard(key);
        if (success) {
            message.success('License key copied to clipboard');
        } else {
            message.error('Failed to copy license key');
        }
    };

    const columns = [
        {
            title: 'Service',
            dataIndex: 'service_name',
            key: 'service_name',
            width: 120,
            render: (service) => {
                const serviceOption = SERVICE_OPTIONS.find(opt => opt.value === service);
                return (
                    <Tag color={serviceOption?.color || 'default'}>
                        {serviceOption?.label || service}
                    </Tag>
                );
            },
        },
        {
            title: 'User',
            dataIndex: 'user',
            key: 'user',
            width: 150,
            render: (user) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <UserOutlined style={{ color: '#1890ff', marginBottom: '8px' }} />
                    <Text strong>{user}</Text>
                </div>
            ),
        },
        {
            title: 'License Key',
            dataIndex: 'license',
            key: 'license',
            width: 300,
            render: (key) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Text code style={{ fontSize: '12px', maxWidth: '200px' }} ellipsis>
                        {key}
                    </Text>
                    <Tooltip title="Copy license key">
                        <Button
                            type="text"
                            size="small"
                            icon={<CopyOutlined />}
                            style={{marginBottom: '8px'}}
                            onClick={() => handleCopy(key)}
                        />
                    </Tooltip>
                </div>
            ),
        },
        {
            title: 'Expire Date',
            dataIndex: 'expire_at',
            key: 'expire_at',
            width: 180,
            render: (date) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CalendarOutlined style={{ color: '#52c41a', marginBottom: '8px' }} />
                    <Text>{dayjs(date).format('YYYY-MM-DD HH:mm')}</Text>
                </div>
            ),
            sorter: (a, b) => dayjs(a.expire_at).unix() - dayjs(b.expire_at).unix(),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, record) => {
                const status = getStatus(record.expire_at);
                return (
                    <Tag color={STATUS_COLORS[status]}>
                        {status.toUpperCase()}
                    </Tag>
                );
            },
        },
    ];

    return (

        <Table
            columns={columns}
            dataSource={licenseKeys}
            rowKey="id"
            loading={loading}
            pagination={false}
            scroll={{ x: 800 }}
        />
    );
};

export default LicenseKeyTable;